<template>
  <div
    class="the-loader"
    :class="'sky-background--' + new Date().getHours()"
  >
    <div class="stones__container">
      <div class="stone stone--top" />
      <div class="stone stone--2" />
      <div class="stone stone--1" />
      <div class="stone stone--bottom" />
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.the-loader {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .stone {
    animation: scale-easeOutElastic 3s;
    animation-fill-mode: forwards;
    opacity: 0;
    background: radial-gradient(at 0 0, #a7a7a7, #90908c);
    margin: 0 auto;

    &--top {
      height: 60px;
      width: 80px;
      border-radius: 30% 60% 60% 40% / 50% 51% 60% 50%;
      transform-origin: 35% bottom;
      animation-delay: 2s;
    }

    &--2 {
      width: 150px;
      height: 45px;
      border-radius: 27% 50% 50% 50% / 50% 53% 50% 50%;
      transform-origin: 40% bottom;
      animation-delay: 1s;
    }

    &--1 {
      width: 180px;
      height: 50px;
      border-radius: 50% 27% 50% 50% / 50% 53% 50% 50%;
      transform-origin: 65% bottom;
    }

    &--bottom {
      width: 210px;
      height: 40px;
      border-radius: 36% 30% 37% 41% / 50% 53% 50% 50%;
      transform-origin: 65% bottom;
      animation: none;
      opacity: 1;
    }
  }

  @keyframes scale-easeOutElastic {
    0% {
      transform: rotateZ(0deg);
      opacity: 1;
    }

    16% {
      transform: rotateZ(-5deg);
      opacity: 1;
    }

    28% {
      transform: rotateZ(4deg);
      opacity: 1;
    }

    44% {
      transform: rotateZ(-4deg);
      opacity: 1;
    }

    59% {
      transform: rotateZ(2deg);
      opacity: 1;
    }

    73% {
      transform: rotateZ(-1deg);
      opacity: 1;
    }

    88% {
      transform: rotateZ(1deg);
      opacity: 1;
    }

    100% {
      transform: rotateZ(0deg);
      opacity: 1;
    }
  }

  .stones__container {
    text-align: center;
  }
}

$backgrounds: (
  #00000c,
  linear-gradient(to bottom, #020111 85%,#191621 100%),
  linear-gradient(to bottom, #020111 60%,#20202c 100%),
  linear-gradient(to bottom, #020111 10%,#3a3a52 100%),
  linear-gradient(to bottom, #20202c 0%,#515175 100%),
  linear-gradient(to bottom, #40405c 0%,#6f71aa 80%,#8a76ab 100%),
  linear-gradient(to bottom, #4a4969 0%,#7072ab 50%,#cd82a0 100%),
  linear-gradient(to bottom, #757abf 0%,#8583be 60%,#eab0d1 100%),
  linear-gradient(to bottom, #82addb 0%,#ebb2b1 100%),
  linear-gradient(to bottom, #94c5f8 1%,#a6e6ff 70%,#b1b5ea 100%),
  linear-gradient(to bottom, #b7eaff 0%,#94dfff 100%),
  linear-gradient(to bottom, #9be2fe 0%,#67d1fb 100%),
  linear-gradient(to bottom, #90dffe 0%,#38a3d1 100%),
  linear-gradient(to bottom, #57c1eb 0%,#246fa8 100%),
  linear-gradient(to bottom, #2d91c2 0%,#1e528e 100%),
  linear-gradient(to bottom, #2473ab 0%,#1e528e 70%,#5b7983 100%),
  linear-gradient(to bottom, #1e528e 0%,#265889 50%,#9da671 100%),
  linear-gradient(to bottom, #1e528e 0%,#728a7c 50%,#e9ce5d 100%),
  linear-gradient(to bottom, #154277 0%,#576e71 30%,#e1c45e 70%,#b26339 100%),
  linear-gradient(to bottom, #163C52 0%,#4F4F47 30%,#C5752D 60%,#B7490F 80%, #2F1107 100%),
  linear-gradient(to bottom, #071B26 0%,#071B26 30%,#8A3B12 80%,#240E03 100%),
  linear-gradient(to bottom, #010A10 30%,#59230B 80%,#2F1107 100%),
  linear-gradient(to bottom, #090401 50%,#4B1D06 100%),
  linear-gradient(to bottom, #00000c 80%,#150800 100%),
  #00000c
);

@for $i from 1 through 25 {
  .sky-background--#{$i} {
    background: nth($backgrounds, $i);
  }
}
</style>
